import { createSelector } from '@reduxjs/toolkit'
import { ReduxState } from './reducers'

export const emailSentSelector = createSelector(
  (state: ReduxState) => state.email,
  state => state.emailSent
)
